import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../state/useAuth';

import { useFavorites } from '../../hooks/useFavorites';
import { getFileUrl } from '../../lib/pb';

export default function Account() {
  const { model } = useAuth();
  const { items, remove, count } = useFavorites();
  const nav = useNavigate();
  return (
    <>
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '0 12px' }}>
        {/* Header */}
        <section style={{ margin: '0 0 18px 0' }}>
          <div
            style={{
              border: '1px solid #e5e7eb',
              borderRadius: 16,
              overflow: 'hidden',
              background: '#fff',
              boxShadow: '0 14px 30px rgba(15,23,42,0.06)'
            }}
          >
            <div
              style={{
                background: 'linear-gradient(135deg, #f8fafc 0%, #eef2ff 60%, #fae8ff 100%)',
                height: 90
              }}
            />
            <div style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '0 16px 14px 16px', marginTop: -28 }}>
              <div style={{
                width: 56, height: 56, borderRadius: 999, background: '#fff',
                border: '1px solid #e5e7eb', display: 'grid', placeItems: 'center',
                boxShadow: '0 8px 20px rgba(2,6,23,0.06)', fontWeight: 700, color: '#111827'
              }}>
                {(model?.name || model?.username || '?').slice(0, 2).toUpperCase()}
              </div>
              <div style={{ flex: 1 }}>
                <h1 style={{ margin: '0 0 2px 0', fontSize: 24 }}>Mon compte</h1>
                <div style={{ color: '#6b7280', fontSize: 14 }}>Bienvenue {model?.name || model?.username || ''}</div>
              </div>
            </div>
          </div>
        </section>
        {model ? (
          <div style={{ display: 'grid', gap: 20 }}>
            <section>
              <div style={{ border: '1px solid #e5e7eb', borderRadius: 16, background: '#fff', overflow: 'hidden' }}>
                <div style={{ padding: '12px 16px', borderBottom: '1px solid #eef0f2', fontWeight: 600 }}>Informations</div>
                <div style={{ display: 'grid', gap: 10, fontSize: 14, padding: 16 }}>
                  <div style={{ display: 'grid', gridTemplateColumns: '140px 1fr', gap: 8 }}>
                    <div style={{ color: '#6b7280' }}>Nom</div>
                    <div>{model.name || '—'}</div>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '140px 1fr', gap: 8 }}>
                    <div style={{ color: '#6b7280' }}>Utilisateur</div>
                    <div>{model.username}</div>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '140px 1fr', gap: 8 }}>
                    <div style={{ color: '#6b7280' }}>Email</div>
                    <div>{model.email || '—'}</div>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '140px 1fr', gap: 8 }}>
                    <div style={{ color: '#6b7280' }}>Rôle</div>
                    <div>{model.role || 'user'}</div>
                  </div>
                </div>
              </div>
            </section>

            <section>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                <h2 style={{ margin: 0, fontSize: 20 }}>Mes favoris {count > 0 && <span style={{ color: '#64748b', fontWeight: 400 }}>({count})</span>}</h2>
              </div>
              {items.length === 0 ? (
                <p style={{ color: '#64748b' }}>Vous n'avez pas encore de favoris.</p>
              ) : (
                <div className="product-list-grid" style={{ marginTop: 8 }}>
                  {items.map((p) => (
                    <article
                      key={p.id}
                      style={{
                        border: '1px solid #eef0f2',
                        borderRadius: 14,
                        overflow: 'hidden',
                        cursor: p.slug ? 'pointer' : 'default',
                        background: '#fff',
                        transition: 'transform .15s ease, box-shadow .15s ease, border-color .15s ease',
                        boxShadow: '0 6px 16px rgba(15,23,42,0.04)'
                      }}
                      onClick={() => { if (p.slug) { nav(`/produits/${p.slug}`); } }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 14px 30px rgba(15,23,42,0.10)';
                        e.currentTarget.style.borderColor = '#e2e8f0';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 6px 16px rgba(15,23,42,0.04)';
                        e.currentTarget.style.borderColor = '#eef0f2';
                      }}
                    >
                      <div style={{ position: 'relative' }}>
                        <div style={{ width: '100%', aspectRatio: '4 / 3', background: '#f1f5f9', borderBottom: '1px solid #e5e7eb' }}>
                          {Array.isArray(p.images) && p.images[0] ? (
                            <img
                              src={getFileUrl(p, p.images[0])}
                              alt={p.title}
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                          ) : null}
                        </div>
                        <button
                          type="button"
                          aria-label="Retirer des favoris"
                          title="Retirer"
                          onClick={(e) => { e.stopPropagation(); remove(p.id); }}
                          style={{ position: 'absolute', top: 8, right: 8, width: 32, height: 32, borderRadius: 8, border: '1px solid #e5e7eb', background: '#fff', display: 'grid', placeItems: 'center', transition: 'background .15s ease, border-color .15s ease' }}
                        >
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <line x1="18" y1="6" x2="6" y2="18" />
                            <line x1="6" y1="6" x2="18" y2="18" />
                          </svg>
                        </button>
                      </div>
                      <div style={{ padding: 10 }}>
                        <div style={{ fontWeight: 600, fontSize: 14, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{p.title}</div>
                      </div>
                    </article>
                  ))}
                </div>
              )}
            </section>
          </div>
        ) : (
          <p>Veuillez vous connecter.</p>
        )}
      </div>
    </>
  );
}
